'use es6';

import { createSelector } from 'reselect';
export const getAccountsState = state => state.accounts;
export const getAccountsProductsByPortal = createSelector(state => state, getAccountsState, (state, accountsState) => {
  const portalId = state.auth.portal.portal_id;

  if (!portalId) {
    return null;
  }

  const accounts = accountsState.get('data');

  if (!accounts) {
    return null;
  }

  const portalAccount = accounts.find(acc => acc.get('id') === portalId);

  if (!portalAccount) {
    return null;
  }

  return portalAccount.get('products');
});